<template>
  <a-spin :spinning="spinning" size="large">
    <div class="login">
      <div class="container">
        <a-row type="flex" justify="center" align="middle" style="height: 100%; width: 100%">
          <a-col :span="6">
            <div class="container-left_image">
              <img src="/login-box-bg.svg" alt="" />
            </div>
            <div class="container-left_title">中免日上工程效能中心</div>
          </a-col>
          <a-col :span="6" />
          <a-col :sm="{ span: 6 }" :xxl="{ span: 5 }">
            <right-menu />
          </a-col>
        </a-row>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { userFeiShuLogin } from '@/api/system/auth';
import RightMenu from '@/pages/login/components/RightMenu';
export default {
  components: { RightMenu },
  data() {
    return {
      spinning: false,
      code: this.$route.query.code || null
    };
  },
  computed: {
    redirectUri() {
      if (this.$router.currentRoute.query.url) {
        return `${process.env.VUE_APP_FS_REDIRECT_URI}?url=${this.$router.currentRoute.query.url}`;
      }
      return process.env.VUE_APP_FS_REDIRECT_URI;
    }
  },
  created() {
    localStorage.removeItem('token');
    localStorage.removeItem('user_info');
    this.handleFeiShuLogin();
  },
  methods: {
    handleFeiShuLogin() {
      if (this.code) {
        this.spinning = true;
        userFeiShuLogin({ code: this.code, redirect_uri: this.redirectUri })
          .then(res => {
            this.spinning = false;
            this.$message.success('登录成功');
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('user_info', JSON.stringify(res.data.user_info));
            this.$store.dispatch('getPermissions');
            if (this.$router.currentRoute.query.url) {
              this.$router.push(this.$router.currentRoute.query.url);
            } else {
              this.$router.push('/');
            }
          })
          .catch(res => {
            this.spinning = false;
            this.$message.warning(res.message);
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
}
.login::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin-left: -48%;
  background-image: url(/login-bg.svg);
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: auto 100%;
  content: '';
  z-index: -1;
}

.container {
  width: 100%;
  height: 100vh;
  padding: auto;

  .login-type {
    text-align: center;
    width: 100%;
  }

  .container-left_image {
    display: block;
    width: 100%;
    img {
      width: 368px;
      height: 190px;
    }
  }
  .container-left_title {
    clear: left;
    width: 368px;
    margin: 56px 0;
    font-size: 1.875rem;
    line-height: 2.25rem;
    color: #fff;
    text-align: center;
  }
}
</style>
